import { Injectable } from '@angular/core';
import { UserType, PermissionType } from '@enums';
import { SxCookieService } from './sx-cookie.service';

import * as fromConfiguration from '@appStore/configuration';
import { Store } from '@ngrx/store';
import { Permission } from '@model';
import { Subject } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SxPermissionService {
  public UserType: UserType;
  public Permissions: Permission[];

  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(private store: Store<fromConfiguration.State>, private sxCookieService: SxCookieService) {
    let permissions$ = this.store.select(fromConfiguration.getPermissions);
    this.UserType = this.sxCookieService.getCookie('SX_LOGGED_IN_AS') as UserType;

    permissions$
      .pipe(
        filter(x => !!x && x.length > 0),
        takeUntil(this.destroy$)
      )
      .subscribe(permissions => {
        this.Permissions = permissions;
        // this.destroy$.next(true);
      });
  }

  public securityTrim(
    userTypes: UserType[],
    permissions: PermissionType[],
    customerId: string,
    managerCompanyId: number
  ) {
    return (
      this.checkUserType(userTypes) &&
      this.checkPermissions(permissions, customerId) &&
      this.checkPermissionsManager(permissions, managerCompanyId)
    );
  }

  public securityTrimByUserType(userTypes: UserType[]) {
    return this.checkUserType(userTypes);
  }

  public securityTrimByPermissions(permissions: PermissionType[], customerId: string) {
    return this.checkPermissions(permissions, customerId);
  }

  checkUserType = (userTypes: UserType[]) => {
    let userTypeCheck = !userTypes || userTypes.some(userType => this.UserType === userType);
    return userTypeCheck;
  };

  checkPermissions(permissions: PermissionType[], customerId: string) {
    if (!permissions) {
      return true;
    }

    let match = false;
    permissions.forEach(targetPermission => {
      let permission = this.Permissions.find(p => p.name === targetPermission);

      match = match || (permission && (!customerId || permission.customers.includes(customerId)));
    });

    return match;
  }

  checkPermissionsManager(permissions: PermissionType[], managerCompanyId: number) {
    if (!permissions) {
      return true;
    }

    let match = false;
    permissions.forEach(targetPermission => {
      let permission = this.Permissions.find(p => p.name === targetPermission);

      match = match || (permission && (!managerCompanyId || permission.managerCompanies.includes(managerCompanyId)));
    });

    return match;
  }

  hasUserManageMeteringPointGroupsPermission = (): boolean =>
    this.securityTrimByUserType([UserType.Company, UserType.Brf, UserType.Manager]) &&
    this.checkPermissions([PermissionType.ManageMeteringPointGroup], null);

  hasUserManageAlarmsPermission = (): boolean => this.checkPermissions([PermissionType.ManageAlarms], null);
}
